import { Pressable } from '@react-aria/interactions'
import { ReactElement } from 'react'
import Styles from './Option.module.scss'
import cx from 'classnames'

interface Props {
  onChange: () => void
  isSelected: boolean
  icon: ReactElement
  description: string
}

export const Option = ({ onChange, isSelected, icon, description }: Props) => {
  return (
    <Pressable onPress={onChange}>
      <div data-testid="option-container" className={cx(Styles.option, { [Styles.selected]: isSelected })}>
        <div className={cx(Styles.iconAndIndicator, { [Styles.selected]: isSelected })}>
          <div className={cx(Styles.icon, { [Styles.selected]: isSelected })}>{icon}</div>
          <div className={cx(Styles.indicator, { [Styles.selected]: isSelected })}>
            <div className={cx({ [Styles.innerCircle]: isSelected })} />
          </div>
        </div>
        <span className={Styles.description}>{description}</span>
      </div>
    </Pressable>
  )
}
